import { useTranslation } from "react-i18next";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useEffect, useState } from "react";
import Card from "./components/Card";
import TogglePeriod from "./components/Toggle";
import useBreakpoints from "@hooks/useBreakPoinst";
import { Swiper, SwiperSlide } from "swiper/react";
import { useLocation } from "react-router-dom";
import {
  PageContainer,
  ContentContainer,
  BackButton,
  StyledArrowRight,
  BackButtonText,
  TitleSection,
  ToggleContainer,
  MobileCardsContainer,
  DesktopCardsContainer,
  StyledSwiper,
  StyledArrowLeft,
} from "./styles";
import { useRTL } from "@hooks/useIsRTL";
import { useSubscription } from "@services";
import CardPlaceholder from "./components/CardPlaceHolder";
import { useNavigate } from "react-router-dom";

interface SubscriptionCardData {
  subscriptionPlanId: string;
  packageName: string;
  packageWithsFeature: {
    features: string[];
  }[];
  priceForEachProperty: string;
  priceForEachPropertyBeforeDiscount: string;
}

const ChoosePlan = () => {
  const { pathname } = useLocation();
  const [subscriptionType, setSubscriptionType] = useState<
    "Yearly" | "Monthly"
  >("Yearly");
  const navigate = useNavigate();

  const { t } = useTranslation();
  const { isPhone } = useBreakpoints();
  const { isRTL } = useRTL();
  const { getSubscriptionDataQuery, useCheckOutAndPayMutation } =
    useSubscription();

  const { data: subscriptionData = [], isLoading } = getSubscriptionDataQuery(
    1,
    subscriptionType
  ) as {
    data: SubscriptionCardData[];
    isLoading: boolean;
  };
  const { mutateAsync: triggerCheckout, isPending: isCheckingOut } =
    useCheckOutAndPayMutation();

  const renderCard = (card: any) => {
    const packageName = card?.packageName;
    const packageId = card?.subscriptionPlanId;
    const packageWithsFeature = card?.packageWithsFeature?.[0]?.features || [];
    const priceForEachProperty = card?.priceForEachProperty;
    const priceForEachPropertyBeforeDiscount =
      card?.priceForEachPropertyBeforeDiscount;

    return (
      <Card
        handleDetails={() => {
          navigate(`/choose-plan/${packageId}/${subscriptionType}`);
        }}
        onPress={() => {
          navigate(`/choose-plan/${packageId}/${subscriptionType}`);
        }}
        key={card.subscriptionPlanId}
        packageName={packageName}
        packageWithsFeature={packageWithsFeature}
        priceForEachProperty={priceForEachProperty}
        priceForEachPropertyBeforeDiscount={
          priceForEachPropertyBeforeDiscount === null
            ? ""
            : priceForEachPropertyBeforeDiscount + " ريال"
        }
      />
    );
  };

  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 50); // delay ensures layout settles
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <PageContainer $isPhone={isPhone}>
        <ContentContainer $isPhone={isPhone}>
          {/* Back button */}
          {pathname === "/choose-plan" && (
            <BackButton onClick={() => navigate("/")} $isPhone={isPhone}>
              {isRTL ? <StyledArrowRight /> : <StyledArrowLeft />}
              <BackButtonText $isPhone={isPhone}>
                {t("chooseSubscription.back")}
              </BackButtonText>
            </BackButton>
          )}

          {/* Title section */}
          <TitleSection $isPhone={isPhone}>
            {t("chooseSubscription.choosePlan")}
          </TitleSection>

          {/* Toggle section */}
          <ToggleContainer $isPhone={isPhone}>
            <TogglePeriod
              selectedPeriod={subscriptionType}
              onChange={setSubscriptionType}
            />
          </ToggleContainer>

          {/* Cards section */}
          {isLoading ? (
            isPhone ? (
              <MobileCardsContainer>
                {mounted && (
                  <StyledSwiper
                    className="mySwiper"
                    modules={[Pagination]} // 👈 this is required
                    pagination={{ clickable: true, dynamicBullets: true }}
                    spaceBetween={10}
                    slidesPerView={1}
                    observer={true}
                    observeParents={true}
                    onSwiper={(swiper) =>
                      setTimeout(() => swiper.update(), 100)
                    }
                  >
                    {[...Array(3)].map((_, i) => (
                      <SwiperSlide key={i}>
                        <CardPlaceholder />
                      </SwiperSlide>
                    ))}
                  </StyledSwiper>
                )}
              </MobileCardsContainer>
            ) : (
              <DesktopCardsContainer>
                {[...Array(3)].map((_, i) => (
                  <CardPlaceholder key={i} />
                ))}
              </DesktopCardsContainer>
            )
          ) : isPhone ? (
            <MobileCardsContainer>
              {mounted && (
                <StyledSwiper
                  className="mySwiper"
                  modules={[Pagination]} // 👈 this is required
                  pagination={{ clickable: true, dynamicBullets: true }}
                  spaceBetween={10}
                  slidesPerView={1}
                  observer={true}
                  observeParents={true}
                  onSwiper={(swiper) => setTimeout(() => swiper.update(), 100)}
                >
                  {Array.isArray(subscriptionData) &&
                    subscriptionData.map((card) => (
                      <SwiperSlide key={card.subscriptionPlanId}>
                        {renderCard(card)}
                      </SwiperSlide>
                    ))}
                </StyledSwiper>
              )}
            </MobileCardsContainer>
          ) : (
            <DesktopCardsContainer>
              {Array.isArray(subscriptionData) &&
                subscriptionData.map(renderCard)}
            </DesktopCardsContainer>
          )}
        </ContentContainer>
      </PageContainer>
    </>
  );
};

export default ChoosePlan;
